// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_stop--solid"><path id="Union" d="M21 20.5C21 20.7761 20.7761 21 20.5 21H3.5C3.22386 21 3 20.7761 3 20.5V3.5C3 3.22386 3.22386 3 3.5 3H20.5C20.7761 3 21 3.22386 21 3.5V20.5Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_stop--line"><path id="Union" d="M21 20.5C21 20.7761 20.7761 21 20.5 21H3.5C3.22386 21 3 20.7761 3 20.5V3.5C3 3.22386 3.22386 3 3.5 3H20.5C20.7761 3 21 3.22386 21 3.5V20.5ZM5 19H19V5H5V19Z" style="fill: currentColor"/></g></svg>`;

export const Stop: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
